export default "__VITE_ASSET__BIkokK$y__"